























import Vue from "vue";
import { get } from "lodash-es";
import request from "@plat-components/utils2/_esm5/request";
import goToVideo from "@/utils/goToVideo";
import safeUrl from "@/utils/safeUrl";
import { videoInfo } from '../constant';

const host = "https://api.bilibili.com";

export const getVideoDetail = async (bvid: string) => {
  const res: any = await request({
    url: host + `/x/web-interface/view`,
    query: {
      bvid
    }
  });
  return res.data;
};

export default Vue.extend({
  props: ["bvid"],
  methods: {
    get,
    goToVideo,
    safeUrl
  },
  data() {
    return {
      // @ts-ignore
      info: videoInfo[this.bvid]
    };
  },
  mounted() {
    // getVideoDetail(this.bvid).then(info => {
    //   this.info = info;
    // });
  }
});
